import styled from 'styled-components';

export const StyledAddModal = styled.div`
  padding: 24px 28px;
`;

export const StyledAddTitle = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 20px;
`;

export const StyledAddContent = styled.div`
  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
